import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import {
  fileInputParams,
  FunctionsService,
  HttpService,
  IButtonlabelEdit,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
  ThousandSeparatorPipe,
} from 'brainloper-ui';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { HistoricalInspections } from 'src/app/models/inspections/historical';
import { HistoricalResponse } from 'src/app/models/inspections/historical-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { Data } from 'src/app/models/commos/base-response-data';
import { InspectionForm } from 'src/app/models/inspections/inspection-form';
import { Question } from 'src/app/models/inspections/question';
import { MatStepper } from '@angular/material/stepper';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { UpdateData } from 'src/app/models/commos/update-data';
import { UploadService } from 'src/app/services/upload.service';

@Component({
    selector: 'app-fill-inspection',
    templateUrl: './fill-inspection.component.html',
    styleUrls: ['./fill-inspection.component.scss'],
    providers: [ThousandSeparatorPipe],
    standalone: false
})
export class FillInspectionComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  public EndpointDictionary = EndpointDictionary;
  public stepsEditable: boolean = true;
  public hasInspectionActive = false;
  public autoComplete: boolean = true;
  public questionsBody: Question[] = [];
  public equipo: Equipment = {};
  public expanded = {};
  public response: HistoricalResponse[] = [];
  public colorPanel = {};
  public fecha: null | Date = null;
  public movil: boolean;
  public showDate: boolean
  public currentOdometer: number = 0;
  private historicalInspections: HistoricalInspections;

  public equipmentSelect: boolean = false;
  public formSelect: boolean = false;
  public haveInspectionsForms: boolean = true;
  public labelsForm: Array<IButtonlabelEdit> = [];
  public labels: string[] = [];
  private paramsEquipmentCombo: params[] = [{ id: 'state', value: '1' }];

  private paramsInspectionEquipmentAndForm: params[] = [
    { id: 'equipmentId', value: '0' },
    { id: 'formId', value: '0' },
  ];
  color = [];

  formStepeOne: UntypedFormGroup;
  public fileInput: fileInputParams = {
    typeFile: 'imagen',
    input: 'vista',
    label: 'foto',
    edit: true,
    style: {
      width: '100%',
      height: screen.width > 400 ? '300px' : '150px',
      border: '1px solid black',
    },
  };

  public imageSources: { [key: number]: string } = {};
  public fileInputs: { [key: number]: fileInputParams } = {};

  menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Inspecciones',
      router: '/mantenimiento/preoperacionales/historico',
    },
    {
      name: 'Diligenciar',
      current: true,
    },
  ];

  public inspectionFormByEquipmentColumns: TableColumns<InspectionForm>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'version',
      label: 'Versión',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'dateFormat',
      label: 'Formato Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'periodicityValue',
      label: 'Periodicidad',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];
  public inspectionFormByEquipmentConfiguration: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id',
  };
  public reloadTableIFByEquipment = new EventEmitter<any>();

  public paramsInspectionFormByEquipment: params[] = [
    { id: 'equipmentId', value: 0 },
  ];

  public inspectionForm: InspectionForm = null;

  constructor(
    private http: HttpService,
    private session: SessionService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private router: Router,
    private storage: LocalStorageService,
    private deleteItem: DeleteGenericService,
    private utils: UtilsServiceService,
    private uploadService: UploadService
  ) {
    this.showDate = this.session.getData('showDate');
  }

  async ngOnInit() {
    this.movil = screen.width > 600 ? false : true;
    await this.validateHasInspectionActive();
    if (!this.hasInspectionActive) {
      this.init();
    }
  }

  ngOnDestroy() {
    this.session.setData('showDate', null);
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando Equipos');
    let res: Array<Equipment> = await this.http.getDataBody(
      `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`,
      this.paramsEquipmentCombo
    );
    if (res) {
      for (let element of res) {
        if (
          element.userId == this.storage.get<number>('userId') &&
          element.state
        ) {
          await this.clickFilaEquipos(element);
          break;
        }
      }
    }
    this.message.closeLoading();
  }

  async clickFilaEquipos($event: Equipment, reload: boolean = true) {
    this.response = [];
    this.message.openLoading('Cargando', 'Cargando Formulario');
    this.equipo = $event;
    this.labels = [`Código del equipo: ${this.equipo.code}`];
    this.paramsInspectionFormByEquipment[0].value = this.equipo.id;
    if (reload) {
      this.reloadTableIFByEquipment.emit('selected');
    }
    this.equipmentSelect = true;
    this.haveInspectionsForms = true;
    this.message.closeLoading();
  }

  dataFromTable($event: Data<InspectionForm[]>) {
    if ($event.data.length > 0) {
      this.haveInspectionsForms = true;
    } else {
      this.haveInspectionsForms = false;
    }
  }

  async clickInspeccionForm(
    $event: InspectionForm,
    getQuestions: boolean = true
  ) {
    this.message.openLoading('Cargando', 'Cargando Preguntas');

    this.inspectionForm = $event;

    if (getQuestions) {
      let questions: Array<Question> = await this.http.getDataBody(
        `${EndpointDictionary.PreopQuestion.PREOP_BY_FORM}/${this.inspectionForm.id}`
      );
      this.questions(questions);
    }

    this.labelsForm = [
      {
        label: 'Código equipo:',
        value: this.equipo.code,
        edit: false,
      },
      {
        label: 'Formulario:',
        value: this.inspectionForm.name,
        edit: false,
      },
    ];
    this.formSelect = true;
    this.message.closeLoading();
  }

  async questions(questions: Array<Question>) {
    this.message.openLoading('Cargando', 'Obteniendo preguntas');
    if (questions) {
      this.response = [];
      this.questionsBody = questions;
      let firstUnansweredIndex: number | null = null;
      for (let element = 0; element < this.questionsBody.length; element++) {
        const currentQuestion = this.questionsBody[element];

        this.expanded[element] = false;
        this.colorPanel[element] = 'background-color:#b7b9bb; color:black;';
        this.color[element] = {};

        currentQuestion.responses[0] === 'Fecha' && currentQuestion.response
          ? this.utils.handlerDateToIsoString(
              new Date(currentQuestion.response).toISOString()
            )
          : currentQuestion.response;

        this.response[element] = {
          question: currentQuestion.question,
          response: currentQuestion.response ?? null,
          id: currentQuestion.historicalResponseId ?? 0,
          responseType: currentQuestion.responses.toString(),
        };

        for (
          let elementButton = 0;
          elementButton < currentQuestion.responses.length;
          elementButton++
        ) {
          if (currentQuestion.responses[0] == 'Numero') {
            this.currentOdometer = this.equipo.currentOdometer ?? 0;
          }
          if (
            currentQuestion.response ===
            currentQuestion.responses[elementButton]
          ) {
            this.color[element][elementButton] = 'warn';
            this.colorPanel[element] = 'background-color:#5d5b5b; color:white;';
          } else {
            this.color[element][elementButton] = 'primary';
          }
        }

        if (currentQuestion.responses[0] === 'Imagen') {
          this.imageSources[element] = currentQuestion.response
            ? this.uploadService.getImagen(
                currentQuestion.response,
                this.storage.get<number>('companyId')
              )
            : '';
          this.fileInputs[element] = {
            ...this.fileInput,
            imageSrc: this.imageSources[element],
          };
        }

        if (
          ['Numero', 'Texto', 'Fecha', 'Imagen'].includes(
            currentQuestion.responses[0]
          ) &&
          currentQuestion.response &&
          this.hasInspectionActive
        ) {
          this.response[element].response = currentQuestion.response;
          this.colorPanel[element] = 'background-color:#5d5b5b; color:white;';
        }
        if (currentQuestion.responses.length === 0) {
          this.color[element] = 'primary';
        }

        if (!currentQuestion.response && firstUnansweredIndex === null) {
          firstUnansweredIndex = element;
        }
      }

      if (firstUnansweredIndex !== null) {
        this.expanded[firstUnansweredIndex] = true;
      } else {
        this.expanded[0] = true;
      }

      this.message.closeLoading();
    }
  }

  async initHistoricalInspection() {
    if (this.questionsBody.length == 0) {
      this.message.Warning(
        'Advertencia',
        'No existen preguntas asociadas a este formulario'
      );
      this.message.closeLoading();
      this.stepper.selectedIndex = 1;
      return;
    }

    this.stepper.next();
    this.stepsEditable = false;
    this.message.openLoading('Cargando', 'Iniciando formulario');

    if (!this.showDate) {
      this.fecha = new Date();
    }

    this.historicalInspections = {
      startDate: this.showDate ? this.functionEter.dateForm(this.fecha) : null,
      executor: this.storage.get<number>('userId'),
      equipmentId: this.equipo.id,
      formId: this.inspectionForm.id,
    };

    var res = await this.http.postDataBody<GenericResponse>(
      EndpointDictionary.HistoryPreop.CRUD_HISTORY_PREOP_DATA,
      this.historicalInspections
    );
    if (res) {
      this.historicalInspections.id = res.insertId;
      this.hasInspectionActive = true;
    }
    this.message.closeLoading();
  }

  async Finalize() {
    if (
      this.response.find(
        (x) => x.response == null || x.response == '' || x.responseType == null
      )
    ) {
      this.message.Warning('Advertencia', 'Complete todas las preguntas');
      return;
    }

    this.message.openLoading('Cargando', 'Finalizando inspección');
    try {
      this.message.SuccessToast('Inspección finalizada exitosamente');
      let body: HistoricalInspections = {
        id: this.historicalInspections.id,
      };
      let res = await this.http.postDataBody(
        EndpointDictionary.HistoryPreop.CLOSE_INSPECTION_HISTORY,
        body
      );
      if (res) {
        this.message.SuccessToast('Inspección almacenada exitosamente');
        setTimeout(() => {
          this.router.navigate(['/inicio']);
        }, 500);
      }
    } catch (error) {
      this.message.Error(
        'Error',
        'Ocurrió un error al finalizar la inspección'
      );
    } finally {
      this.message.closeLoading();
    }
  }

  async selectResponse(
    response: string,
    index: number,
    data: Question,
    indexButton: number
  ) {
    if (this.color[index][indexButton] === 'warn') {
      return;
    }

    for (let i = 0; i < this.questionsBody[index].responses.length; i++) {
      this.color[index][i] = 'primary';
    }

    this.response[index] = {
      ...this.response[index],
      question: data.question,
      response,
      historicalInspectionId: this.historicalInspections.id,
      responseType: data.responses.toString(),
    };

    if (await this.saveResponseToHistory(this.response[index], index)) {
      this.color[index][indexButton] = 'warn';
      this.changeStyleQuestion(index);
    }
  }

  changeStyleQuestion(index: number) {
    setTimeout(() => {
      this.colorPanel[index] = 'background-color:#5d5b5b; color:white;';
      this.expanded[index] = false;
      this.expanded[index + 1] = true;
    }, 100);
  }

  async textResponse(
    index: number,
    data: Question,
    updateOdometer: boolean = false
  ) {
    let respose = this.response[index].response.toString();
    let numResponse = Number(respose?.replace(/[,.]/g, ''));

    if (updateOdometer && !this.showDate) {
      if (isNaN(numResponse)) {
        this.message.Error('Error', 'Ingrese un valor válido');
        this.response[index].response = null;
        return;
      }

      if (numResponse <= this.currentOdometer) {
        let value = new ThousandSeparatorPipe().transform(this.currentOdometer);
        this.message.Error(
          'Error',
          'El valor del medidor debe ser mayor que ' + value
        );
        this.response[index].response = null;
        return;
      }
      let form = {
        id: this.equipo.id,
        currentOdometer: numResponse,
      };
      await this.http.putDataBody(
        `${EndpointDictionary.Equipment.EQUIPMENT_KM}`,
        form
      );
    }

    if (!respose) {
      this.response[index].response = 'N/A';
    } else if (updateOdometer) {
      this.response[index].response = numResponse.toString();
    } else {
      this.response[index].response = respose;
    }

    this.response[index] = {
      ...this.response[index],
      response: this.response[index].response,
      responseType: data.responses.toString(),
      historicalInspectionId: this.historicalInspections.id,
    };

    if (await this.saveResponseToHistory(this.response[index], index)) {
      this.changeStyleQuestion(index);
      this.color[index] = 'warn';
    }
  }

  async dateResponse(index: number, data: Question) {
    const selectedDate = this.response[index].response;
    const formattedDate = this.utils.handlerDateToIsoString(
      new Date(selectedDate).toISOString()
    );

    this.response[index] = {
      ...this.response[index],
      response: formattedDate,
      responseType: data.responses.toString(),
      historicalInspectionId: this.historicalInspections.id,
    };

    if (await this.saveResponseToHistory(this.response[index], index)) {
      this.changeStyleQuestion(index);
    }
  }

  async autoComplit() {
    this.message.openLoading('Cargando', 'Completando formulario');
    try {
      for (let element of this.paramsInspectionEquipmentAndForm) {
        if (element.id == 'equipmentId') {
          element.value = this.equipo.id;
        }
        if (element.id == 'formId') {
          element.value = this.inspectionForm.id;
        }
      }
      let res: HistoricalInspections = await this.http.getDataBody(
        `${EndpointDictionary.HistoryPreop.INSPECTION_ACTIVE_BY_EQUIPMENT_AND_FORM}`,
        this.paramsInspectionEquipmentAndForm
      );

      if (!res || !res.questions || res.questions.length === 0) {
        this.message.Warning(
          'Ups!',
          'No se encuentran registros anteriores por favor diligencias formulario'
        );
        this.message.closeLoading();
        return;
      }
      let index = 0;
      for (let element of this.questionsBody) {
        for (let i of res.questions) {
          let indexButton = 0;
          if (element.question == i.question) {
            if (element.responses[0] === 'Fecha') {
              const formattedDate = this.utils.handlerDateToIsoString(
                new Date(i.response).toISOString()
              );
              this.response[index] = {
                ...this.response[index],
                response: formattedDate,
                responseType: element.responses.toString(),
                historicalInspectionId: this.historicalInspections.id,
              };
              this.dateResponse(index, element);
            } else {
              for (let respuesta of element.responses) {
                if (respuesta == i.response) {
                  this.selectResponse(i.response, index, element, indexButton);
                  continue;
                }
                indexButton = indexButton + 1;
              }
              continue;
            }
          }
        }
        index = index + 1;
      }

      this.message.closeLoading();
    } catch (error) {
      this.message.Error('Error', error['message']);
      this.message.closeLoading();
    }
  }

  async cancelInspectionForm() {
    let deleteInspectionForm = await this.message.Warning(
      'Advertencia',
      'Si cancela la inspeccción se borrara cualquier registro que lleva, ¿Desea Eliminar la inspección?',
      true,
      'Sí',
      'No'
    );
    if (deleteInspectionForm) {
      this.message.openLoading('Cargando', 'Cancelando Inspección');
      let res = await this.deleteItem.deleteWhitoutWarning(
        EndpointDictionary.HistoryPreop.CRUD_HISTORY_PREOP_DATA,
        this.historicalInspections.id
      );
      if (res) {
        this.message.SuccessToast('Inspección eliminada exitosamente');
        this.router.navigate(['inicio']);
      }
      this.message.closeLoading();
    }
  }

  errorMessage() {
    this.message.Error('Error', 'Seleccione un formulario');
  }

  async fileSave($event: UpdateData<File>, index: number, data: Question) {
    this.expanded[index] = true;
    this.expanded[index + 1] = false;
    let file = null;

    if ($event.compressor) {
      file = $event.compressor;
    } else {
      file = $event.new;
    }

    if (!file) {
      this.message.Warning(
        'Advertencia',
        'Debe seleccionar una imagen antes de enviar.'
      );
      return;
    }

    this.message.openLoading('Cargando', 'Subiendo imagen');
    try {
      const photoUrl = await this.uploadService.uploadFile(file);

      if (photoUrl) {
        this.response[index] = {
          ...this.response[index],
          response: photoUrl,
          responseType: data.responses.toString(),
          historicalInspectionId: this.historicalInspections.id,
        };

        this.imageSources[index] = photoUrl;
        this.fileInputs[index].imageSrc = photoUrl;

        if (await this.saveResponseToHistory(this.response[index], index)) {
          this.changeStyleQuestion(index);
        }
      } else {
        this.message.Error('Error', 'No se pudo guardar la imagen');
      }
    } catch (error) {
      this.message.Error('Error', 'Ocurrió un error al guardar la imagen');
    } finally {
      this.message.closeLoading();
    }
  }

  onContinueEquipment() {
    if (!this.haveInspectionsForms) {
      this.message.Warning(
        'Advertencia',
        'No existen formularios asociadas a este equipo'
      );
      this.message.closeLoading();
      if (this.stepper) {
        this.stepper.selectedIndex = 0;
      }
      return;
    }
  }

  private async validateHasInspectionActive() {
    this.message.openLoading('Cargando', 'Validando inspección actual');
    let res = await this.http.getDataBody<HistoricalInspections>(
      EndpointDictionary.HistoryPreop.HAS_INSPECTION_ACTIVE
    );
    if (res && res.id) {
      this.hasInspectionActive = true;
      this.historicalInspections = res;
      this.fecha = new Date(res.startDate);

      const equipment = {
        id: res.equipmentId,
        code: res.code,
        currentOdometer: res.currentOdometer,
      } as Equipment;
      await this.clickFilaEquipos(equipment, false);

      const form = {
        id: res.formId,
        name: res.formName,
      } as InspectionForm;
      await this.clickInspeccionForm(form, true);

      await this.questions(this.historicalInspections.questions);
      this.stepper.selectedIndex = 2;
      this.stepsEditable = false;
    } else {
      this.hasInspectionActive = false;
    }
    this.message.closeLoading();
  }

  private async saveResponseToHistory(
    response: HistoricalResponse,
    index: number
  ): Promise<boolean> {
    try {
      this.message.openLoading('Cargando', 'Guardando Respuestas');
      if (response.id) {
        const resPreguntas: GenericResponse = await this.http.putDataBody(
          `${EndpointDictionary.PreopRHistory.CRUD_PREOP_R_HISTORY_DATA}`,
          response
        );
        if (resPreguntas) {
          this.message.closeLoading();
          return true;
        } else {
          this.message.Error('Error', 'No se pudo actualizar la respuesta');
          this.message.closeLoading();
          return false;
        }
      } else {
        const resPreguntas: GenericResponse = await this.http.postDataBody(
          `${EndpointDictionary.PreopRHistory.CRUD_PREOP_R_HISTORY_DATA}`,
          response
        );
        if (resPreguntas) {
          this.response[index].id = resPreguntas.insertId;
          this.message.closeLoading();
          return true;
        } else {
          this.message.Error('Error', 'No se pudo guardar la respuesta');
          this.message.closeLoading();
          return false;
        }
      }
    } catch (error) {
      this.message.Error('Error', 'Ocurrió un error al guardar la respuesta');
      this.message.closeLoading();
      return false;
    }
  }
}
